<template>
  <div>
    <b-container class="py-3">
      <b-row>
        <b-col>
          <page-title v-if="isAuthenticated" title="Welcome" />
          <div v-if="isAuthenticated">
            <hr />
            <p>You are already logged in as {{$root.$data.authenticatedUser.username}}.</p>
          </div>
          <div v-if="!isAuthenticated">
            <b-row>
              <b-col md="3"></b-col>
              <b-col md="6" class="text-center">
                <page-title title="Welcome to Justice Story" />
                <p>Please enter your email address below. Be sure to use the email address provided by your team administrator. An email will then be sent to you with a link to create your password so you can start using your Justice Story account.</p>
                <p>If you have any questions or issues, please contact us at <a href="mailto:info@justicestory.com">info@justicestory.com</a>.</p>
              </b-col>
              <b-col md="3"></b-col>
            </b-row>
            <auth-form @authenticated="onAuthenticated" page="requestReset" request-password-reset-header="Get Started" class="mt-3" />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import axios from "axios";
import AuthMixin from '../Mixins/AuthMixin.vue';

export default {
  name: "Login",
  mixins: [AuthMixin],
  props: {},
  data() {
    return {
    }
  },
  methods: {
    onAuthenticated: function () {
      if (this.$route.query.redirect)
        this.$router.push(this.$route.query.redirect);
      else
        this.$router.push('/');
    }
  },
  mounted () {
    if (this.$root.$data.authenticated && this.$root.$data.authenticatedUser.username.length > 0) {
      this.onAuthenticated();
    } else if ((!this.$root.$data.authenticatedUser || !this.$root.$data.authenticatedUser.username) && localStorage.getItem('jwt')) {
      axios.defaults.headers.common['Authorization'] = "Bearer " + localStorage.getItem('jwt');

      this.$root.$data.authenticatedUser.username = localStorage.getItem('username');
      this.$root.$data.authenticatedUser.id = localStorage.getItem('id');
      this.$root.$data.authenticatedUser.roles = JSON.parse(localStorage.getItem('roles'));

      this.onAuthenticated();
    }
  }
};
</script>